<template>
  <footer class="footer footer-black footer-white">
    <div class="container-fluid">
      <div class="row">
        <nav class="footer-nav">
          <ul>
            <li>
              <a href="https://cabcard.services">CabCard Services</a>
            </li>
            <li>
              <a href="https://cabcard.services/support">Support</a>
            </li>
          </ul>
        </nav>
        <div class="credits ml-auto">
          <div class="copyright pull-right">&copy; 2019 CabCard Services Limited</div>
        </div>
      </div>
    </div>
  </footer>
</template>
<script>
export default {
  name: "main-footer"
};
</script>
<style>
</style>
